import { Route, Routes, useLocation } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import './App.scss';
import Home from './pages/Home';
import PortfolioIndex from './pages/PortfolioIndex';
import PortfolioDetail from './pages/PortfolioDetail';
import PageNotFound from './pages/PageNotFound';
import ContactMe from './pages/ContactMe';
import FormSuccess from './pages/FormSuccess';
import { useState, useEffect } from 'react';
import Menu from './components/Menu';
import PageWrapper from './components/PageWrapper';

function App() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const location = useLocation();

	const toggleMenu = () => {
		setIsMenuOpen(prev => !prev);
	};

	useEffect(() => {
		if (isMenuOpen) {
			document.documentElement.classList.add('overflow-hidden');
		} else {
			document.documentElement.classList.remove('overflow-hidden');
		}
		return () => {
			document.documentElement.classList.remove('overflow-hidden');
		};
	}, [isMenuOpen]);

	return (
		<main>
			{isMenuOpen && <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />}
			<AnimatePresence mode="wait">
				<Routes location={location} key={location.pathname}>
					<Route
						path="/"
						element={
							<PageWrapper>
								<Home toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
							</PageWrapper>
						}
					/>
					<Route
						path="/portfolio"
						element={
							<PageWrapper>
								<PortfolioIndex
									toggleMenu={toggleMenu}
									isMenuOpen={isMenuOpen}
								/>
							</PageWrapper>
						}
					/>
					<Route
						path="/portfolio/:slug"
						element={
							<PageWrapper>
								<PortfolioDetail
									toggleMenu={toggleMenu}
									isMenuOpen={isMenuOpen}
								/>
							</PageWrapper>
						}
					/>
					<Route
						path="*"
						element={
							<PageWrapper>
								<PageNotFound />
							</PageWrapper>
						}
					/>
					<Route
						path="/contact-me"
						element={
							<PageWrapper>
								<ContactMe toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
							</PageWrapper>
						}
					/>

					<Route
						path="success"
						element={
							<PageWrapper>
								<FormSuccess />
							</PageWrapper>
						}
					/>
				</Routes>
			</AnimatePresence>
		</main>
	);
}

export default App;
